import { z } from 'zod';
import { DecimalString } from './common.js';

/** POST /api/users/convert/mp-uo — MP → ORB (10:1) */
export const MpUoConvertSchema = z.object({
  mp_amount: DecimalString,
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
  memo: z.string().max(500).optional(),
  idempotency_key: z.string().max(64).optional(),
});

export type MpUoConvertRequest = z.infer<typeof MpUoConvertSchema>;
